<template>
    <section class="content">
        <div class="container-fluid">
          
                <div class="card">
                    <div class="fn-header">
                       
                        <span>แสดงรายการแพคเกจ</span>
                    </div>

                    <div class="row search-section">
                        <div class="col-sm-2 col-search" style="text-align: left;">
                        <AutoPackage ref="auto_package" packageId="package-record"  classname="form-control fn-box"  />
                        </div>
                        <div class="col-sm-1 col-search">
                            <select v-model="price" class="form-control  show-tick fn-required">
                                <option value="0">ราคาทั้งหมด</option>
                                 <option v-for="(value,index) in prices" :key="'price-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-2 col-search">
                           
                            <select v-model="user_id" class="form-control  show-tick fn-required">
                                <option value="0">ผู้ใช้งานทั้งหมด</option>
                                 <option v-for="(user,index) in users" :key="'user-key-' + index" :value="user.id" v-html="user.name"></option>
                            </select>
                        </div>
                        <div class="col-sm-4 col-search" style="display: flex;">
                            <date-picker v-model="start_date"  format="DD-MM-YYYY" placeholder="วันเริ่มต้น"/>
                            <div style="width: 30px;">-</div>
                            <date-picker  v-model="end_date" format="DD-MM-YYYY" placeholder="วันสิ้นสุด"/>
                        </div>
                       
                       
                        <div class="col-sm-2 col-search">
                            <button type="button" class="btn bg-blue-grey waves-effect btn-search" :disabled="loading" @click="search(1)">
                                <i class="material-icons">search</i>
                                <span>ค้นหา</span>
                            </button> 
                        </div>
                        <div class="col-sm-1 col-search">
                            <button type="button" class="btn bg-grey waves-effect btn-search"  :disabled="loading" @click="reset()">
                                <i class="material-icons">refresh</i>
                                <span>Reset</span>
                            </button> 
                        </div>   
                       
                    </div>
                   
                    
                    <div class="body table-responsive" style="width:100%" >
                        <div class="preloader pl-size-xl"  v-if="loading == true">
                            <div class="spinner-layer pl-orange">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-sm-6" style="text-align: left;">
                                <div class="p-title">แสดงรายการระหว่าง  วันที่ {{ start_date_text }} - {{ end_date_text }}</div>
                            </div>
                            <div class="col-sm-5"> </div>
                            <div class="col-sm-1" style="text-align: right;"> 
                                <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;" @click="download()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                                <b>จำนวนสั่งซื้อทั้งหมด:</b> {{  total_amount  | comma }} ครั้ง
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="text-align: left;">
                               <b> ราคารวมทั้งหมด:</b> {{  total_price  | comma }} บาท
                            </div>
                        </div>
                        <div class="row" v-if="user.role_id == 1">
                            <div class="col-sm-12" style="text-align: left;">
                               <b> กำไร:</b> {{  total_profit  | comma2 }} บาท
                            </div>
                        </div>
              
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th">No.</th>
                                    <th class="fn-th">แพคเกจ</th>
                                    <th class="fn-th">ราคา</th>
                                    <th class="fn-th">จำนวนสั่งซื้อ</th>
                                    <th class="fn-th">ราคารวม</th>
                                    <th class="fn-th"  v-if="user.role_id == 1">กำไร</th>
                                    <th class="fn-th">วันที่</th>
                                    <th class="fn-th">ผู้บันทึก</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in items" :key="uniq()" :class="{'fn-tr-light' : index % 2 ,'fn-tr-dark' : !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1" style="width: 100px;"></td>
                                    <td style="text-align: center;">
                                      
                                            <span>{{ item.package_name }}</span>
                                        
                                    </td>
                                    
                                    <td style="text-align: center;">
                                         <span>{{ item.price | comma }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                         <span>{{ item.amount }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                         <span>{{ item.total | comma }}</span>
                                    </td>
                                    <td style="text-align: center;"  v-if="user.role_id == 1">
                                         <span>{{ item.total_profit }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.create_datetime | date }}</span>
                                    </td>

                                      <td style="text-align: center;">
                                        <span> {{ item.name }}</span>
                                    </td>
                                    <td>
                                        <span @click="deleteRecord(item.record_id)" v-if="user.role_id == 1 || user.id == item.create_by">
                                                <a href="#">
                                                    <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                                </a>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                           
                        </table>
                    </div>

                        <Paginate
                            v-model=page
                            :page-count=pages
                            :page-range="5"
                            :click-handler="search"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'fn-pagination'"
                        />
                        
                    </div>
                </div>
        </div>
   
    </section>
</template>

<script>

import { RecordService,PropertyService } from '../../service'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import uniqid from 'uniqid';
import alertBox from '../../classes/alertBox'
import AutoPackage from '../AutoComplete/AutoPackage.vue';
import Paginate from 'vuejs-paginate'

export default {
    name : "RecordList",
    components: {
        DatePicker,
        AutoPackage,
        Paginate
    },
    data(){
        return {
            user:JSON.parse(localStorage.getItem('user')),
            id: 0,
            page : 1,
            perpage : 50,
            total : 8,
            pages : 1,
            block_set : 5,
            block_index : 0,
            blocks : [],
            items: [],
            date:localStorage.getItem('date'),
            loading : false,
            key:"",
            start_date:null,
            end_date:null,
            start_date_text:"",
            end_date_text:"",
            package_name:"",
            user_id:0,
            price:0,
            users:[],
            prices:[],
            total_amount:0,
            total_price:0,
            total_profit:0,
            search_params:{}
        }
    },
    
    async created() {
     
        this.start_date =  new Date(this.date)
        this.end_date =  new Date(this.date)
        this.start_date_text = moment(this.date).format('DD/MM/YYYY')
        this.end_date_text =moment(this.date).format('DD/MM/YYYY')
        let response = await PropertyService.get()
        if(response && response.status){
            this.users = response.users
            this.prices = response.prices
        }
        this.search(1)
      
    },
    mounted(){

    },
    watch: {
        start_date(val){
          this.end_date = val
        }
    },
    methods: {
        uniq(){
            return uniqid()
        },
        async search(p){
            this.loading = true
            let package_id = this.$refs.auto_package.package_id
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            this.start_date_text = moment(this.start_date).format('DD/MM/YYYY')
            this.end_date_text =moment(this.end_date).format('DD/MM/YYYY')
            this.search_params ={
                package_id: package_id,
                price:this.price,
                user_id:this.user_id,
                page: p,
                perpage:this.perpage,
                startDate:start_date,
                endDate:end_date
            }
            let response = await RecordService.search(this.search_params)
          
            if(response.status)
            {
                let{page,perpage,total,pages,data,total_amount,total_price,total_profit} = response.result
                this.page = parseInt(page)
                this.perpage = parseInt(perpage)
                this.total = total
                this.pages = pages
                this.items = data
                this.total_amount = total_amount
                this.total_price = total_price
                this.total_profit = total_profit
              
            }
            setTimeout(() => {
                this.loading = false
            }, 500);
           
        },
        
        reset(){
            this.$refs.auto_package.package_id = 0
            this.$refs.auto_package.package_name = ""
            $("#package-record").val("")
            this.user_id = 0
            this.price = 0
            this.user_id = 0
            // this.start_date = new Date(this.date)
            // this.end_date = new Date(this.date)
            this.search(1)
        },
        deleteRecord(id){
            var vm = this
            let package_name = ""
            let price = ""
            let create_datetime = ""
            let name = ""
            let amount = ""
            let item = this.items.find(x => x.record_id == id)
            if(item){
                package_name = item.package_name
                price = item.price
                create_datetime = moment( item.create_datetime).format('DD/MM/YYYY HH:mm')
                name = item.name
                amount = item.amount
            }
            let message  = '<span style="font-size:14px;font-weight: bold">คุณแน่ใจที่จะลบ ' +
               '<br><span style="color:red">' + package_name + '</span> <span style="color:green">' + price + "</span><br>จำนวน: " +  amount + 
              '<br><span>' + create_datetime + "</span>"+
              '<br><span>ผู้บันทึก: ' + name + "</span></span>";
            alertBox.confirm3(message).then(async function(result){
                if (result) {
                    var response = await RecordService.delete(id,vm.user.id)
                   
                    if(response.status){
                      vm.search(1)
                    }
                    else{
                        alertBox.error("Error, " + response.error)
                    }
                }
            })
        },
        download(){
            let url = `${process.env.API}/record/download`
            let fileName = 'รายการแพคเกจ_' + moment(this.date).format('YYYYMMDD_HHmmss') +'.xlsx'
            let {package_id,price,user_id,page,startDate,endDate} = this.search_params
          
            var request = new XMLHttpRequest();
            request.onload = function(e) {
                if (this.status === 200) {
                   
                        var blob = this.response;
                        if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, fileName);
                            
                        }
                        else{
                            var downloadLink = window.document.createElement('a');
                            var contentTypeHeader = request.getResponseHeader("Content-Type");
                            downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            
                        }
                    
                }
                else{
                    alertBox.error("Error ,Can not download")
                    
                }
               
            };
            
            request.open('POST', url);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.setRequestHeader('Access-Control-Allow-Origin', '*');
            request.responseType = 'blob';
            let params = `package_id=${package_id}&price=${price}&user_id=${user_id}&page=${page}&perpage=50000&startDate=${startDate}&endDate=${endDate}`
           
            request.send(params);
        }
    },
    filters:{
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma2(value)
        },
        date(value){
            if(!value) return ""

            return  moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
    
    .link{
        color: white;
        font-weight: bold;
        text-decoration: underline;
    }
    .p-title{
        font-weight: bold;
        margin-top: 20px;
    }
    .p-price{
        text-align: right;
        padding-right: 30px;
    }
   

</style>


// WEBPACK FOOTER //
// src/components/Record/RecordList.vue